import React, { Component } from "react";
import Clock from "react-live-clock";

class LiveCloock extends Component {
  render() {
    return (
      <div>
        <Clock
          style={{ color: "#e4e6eb" }}
          format={"YYYY 년 MM 월 DD 일 HH:mm:ss"}
          ticking={true}
        />
      </div>
    );
  }
}

export default LiveCloock;
